module.exports = __webpack_public_path__ + "static/media/5.4accd098.jpg";